import React, { FC } from "react";
import propTypes from "prop-types";
import { FaCar } from "react-icons/fa";
import {
    FiUser,
    FiChevronRight,
    FiHome,
} from 'react-icons/fi';

import { VehicleAudit } from "../../../../logic/api";

import styles from "./styles";
import flex from "../../../../styles/flex";

import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";

import { locationPathTextToFriendly } from "../../../../utility/utils";
import { useDate } from "../../../../utility/useDate";
import { useTranslation } from "react-i18next";

const VehicleAuditListItem: FC<{ item: VehicleAudit, onClick?: () => void }> = (props) => {
    const border = styles.border
    const { toFormattedDateTimeString } = useDate();
    const { t } = useTranslation();

    return <div style={{ ...styles.listItem, ...border }} onClick={() => {
        if (props.onClick != null) {
            props.onClick();
        }
    }}>
        <div style={{ position: "absolute", textAlign: "center", width: 120, left: -67, bottom: 0, height: 15, top: 30, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", color: "white", transform: "rotate(270deg)" }}>
            <span>{t("lists.laneAudit")}</span>
        </div>
        <div style={styles.listItemFlex}>
            <ListViewItemCard
                icon={<FiHome style={styles.icon} />}
                text={props.item.location.name}
                subText={locationPathTextToFriendly(props.item.location.pathText)}
            />
            <ListViewItemCard
                icon={<FaCar style={styles.icon} />}
                text={t("lists.missing&UnexpectedCount", { count: props.item.missingCount, unexpected: props.item.unexpectedCount })}
                subText={t("lists.scanCount", { count: props.item.scanCount })}

            />
            <ListViewItemCard
                icon={<FiUser style={styles.icon} />}
                text={`${props.item.createdBy.firstName} ${props.item.createdBy.lastName}`}
                subText={toFormattedDateTimeString(new Date(props.item.createDate))}
            />
            <div style={flex.flexAuto}>
                <div style={{ ...flex.flexRows, alignItems: "center", height: "100%" }}>
                    <div style={flex.flexAuto}>
                        <FiChevronRight style={styles.iconChevron} />
                    </div>
                </div>
            </div>
        </div>
    </div>
}


VehicleAuditListItem.propTypes = {
    item: propTypes.any.isRequired,
    onClick: propTypes.func
};


export default VehicleAuditListItem;